<template>
    <div class="text-center border-radius-1">
        <v-dialog
            dark
            width="500"
            :persistent="persistent"
            v-model="visible"
            overlay-opacity=".95"
            overlay-color="primary"
            class="border-radius-1"
            >

            <v-img 
                :src="icon"
                class="dialog-icon"
                height="75"
                width="75"
                v-if="modalType === 'custom'"
                />

            <v-img 
                :src="require('@/assets/img/icons/icon-information.png')"
                class="dialog-icon"
                height="75"
                width="75"
                v-if="modalType === 'info'"
                />

            <v-img 
                :src="require('@/assets/img/icons/icon-warning-stroke.png')"
                class="dialog-icon"
                height="75"
                width="75"
                v-if="modalType === 'confirm'"
                />
            <v-img 
                :src="require('@/assets/img/icons/treasure-stroke.png')"
                class="dialog-icon"
                height="75"
                width="75"
                v-if="modalType === 'rewards'"
                />

            <v-card
                justify="center"
                align="center"
                class="border-radius-1 pa-5"
                color="#fff"
            >
                <!-- <v-card-title :class="` text-center w-100 d-flex justify-center align-center text-h4 ${colorTitle}`"> -->
                <v-card-title class="text-center w-100 d-flex justify-center align-center text-h5">
                    {{ title }}
                </v-card-title>
                <!-- <v-card-text :class="`subtitle ${colorTitle} pt-7 pb-7`"> -->
                <v-card-text class="subtitle pt-4 pb-4">
                    {{ text }}
                </v-card-text>

                <v-card-actions
                    :class="
                        'px-10 py-5 d-flex align-center ' +
                        ((modalType === 'confirm' || modalType === 'loadError' ) ? 'justify-space-around' : 'justify-center ')
                    "
                >
                    <v-btn
                        color="white"
                        class="px-16 py-5 white--text border-radius-1 text-transform-none font-weight-bolder"
                        outlined
                        @click="hide()"
                        v-if="modalType === 'confirm'"
                    >
                        {{ $t('button_no') }}
                    </v-btn>
                    <v-btn
                        color="white"
                        class="px-16 py-5 primary--text border-radius-1 text-transform-none font-weight-bolder"
                        @click="
                            onConfirm()
                            visible = false
                        "
                        v-if="modalType === 'confirm'"
                    >
                        {{ $t('button_yes') }}
                    </v-btn>
                    <v-btn
                        data-cy="close-button-error"
                        color="white"
                        class="px-16 py-5 primary--text border-radius-1 text-transform-none font-weight-bolder"
                        v-if="modalType !== 'confirm' && modalType !== 'loadError' && modalType !== 'custom'"
                        @click="hide"
                    >
                        {{ $t('button_close') }}
                    </v-btn>
                    <v-btn
                        color="white"
                        class="px-16 py-5 border-radius-1 white--text"
                        v-if="modalType === 'loadError'"
                        outlined
                        @click="goBack"
                    >
                        {{ $t('go_back') }}
                    </v-btn>
                    <v-btn
                        color="white"
                        class="px-16 py-5 primary--text border-radius-1 text-transform-none font-weight-bolder"
                        v-if="modalType === 'loadError'"
                        rounded
                        @click="reload"
                    >
                        {{ $t('button_accept') }}
                    </v-btn>
                    <v-btn
                        color="white"
                        class="px-16 py-5 primary--text border-radius-1 text-transform-none font-weight-bolder"
                        v-if="modalType === 'custom'"
                        rounded
                        @click="hide"
                    >
                        {{ buttonText }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
/* eslint-disable import/no-cycle */
// eslint-disable-next-line import/extensions
import Modal from '@/plugins/modal.js'

export default {
    data() {
        return {
            // variable that shows/hides modal
            visible: false,
            title: '',
            text: '',
            // icon: '',
            buttonText: '',
            modalType: '',
            persistent: false,
            modalIcon: '',
            cssTitle: '',
            resolve: null,
            reject: null,
            onConfirm: null,
            onCancel: null,
        }
    },
    methods: {
        hide(cancelCallback) {
            this.visible = false 
            if (cancelCallback && typeof cancelCallback === 'function') {
                cancelCallback()
            }
            if(this.onCancel) this.onCancel()
        },
        confirm(title, message, callback, cancelCallback) {
            this.visible = true
            this.title = title || this.$t('msg_confirm-default')
            this.text = message
            this.modalType = 'confirm'
            this.persistent = true
            this.onConfirm = callback
            this.onCancel = cancelCallback
        },
        custom(title, message, icon, buttonText, callback, cancelCallback) {
            this.visible = true
            this.title = title
            this.text = message
            this.icon = icon
            this.buttonText = buttonText || this.$t('button_close')
            this.modalType = 'custom'
            this.persistent = true
            this.onConfirm = callback
            this.onCancel = cancelCallback
        },
        show(params) {
            this.visible = true
            this.title = params.title || this.$t('msg_info')
            this.text = params.text || this.$t('msg_confirm-default')
            this.modalType = params.modalType || 'confirm'
        },
        error(text) {
            this.visible = true
            this.title = this.$t('msg_error')
            this.text = text
            this.modalType = 'error'
        },
        warning(text) {
            this.visible = true
            this.title = this.$t('msg_warning')
            this.text = text
            this.modalType = 'warning'
        },
        info(text) {
            this.visible = true
            this.title = this.$t('msg_info')
            this.text = text
            this.modalType = 'info'
        },
        success(text) {
            this.visible = true
            this.title = this.$t('msg_success')
            this.text = text
            this.modalType = 'success'
        },
        rewards(title, message) {
            this.visible = true
            this.title = title || this.$t('msg_rewards')
            this.text = message
            this.modalType = 'rewards'
        },
        agree() {
            this.resolve(true)
            this.visible = false
        },
        cancel() {
            this.resolve(false)
            this.visible = false
        },
        loadError(text = null) {
            this.visible = true
            this.title = this.$t('msg_load_error')
            this.text = text || this.$t('txt_load_error')
            this.modalType = 'loadError'
        },
        reload() {
            this.visible = false
            this.$router.go()
        },
        goBack() {
            this.visible = false
            this.$router.go(-1)
        },
    },
    computed: {
        colorTitle() {
            return 'primary--text'
        },
        icon() {
            switch (this.modalType) {
                case 'error':
                    return 'mdi mdi-close-circle'
                case 'warning':
                    return 'mdi mdi-alert'
                case 'success':
                    return 'mdi mdi-checkbox-marked-circle'
                case 'info':
                    return 'mdi mdi-alert-circle'
                default:
                    return ''
            }
        },
    },
    beforeMount() {
        Modal.EventBus.$on('show', (params) => {
            this.show(params)
        })

        Modal.EventBus.$on('error', (params) => {
            this.error(params)
        })

        Modal.EventBus.$on('warning', (params) => {
            this.warning(params)
        })

        Modal.EventBus.$on('info', (params) => {
            this.info(params)
        })

        Modal.EventBus.$on('success', (params) => {
            this.success(params)
        })
        
        Modal.EventBus.$on('rewards', (title, message) => {
            this.rewards(title, message)
        })

        Modal.EventBus.$on('loadError', (params) => {
            this.loadError(params)
        })

        Modal.EventBus.$on('confirm', (title, message, callback, cancelCallback) => {
            return this.confirm(title, message, callback, cancelCallback)
        })
        
        Modal.EventBus.$on('custom', (title, message, icon, buttonText, callback, cancelCallback) => {
            return this.custom(title, message, icon, buttonText, callback, cancelCallback)
        })
    },
}
</script>

<style scoped>
.subtitle {
    font-size: 16px;
    font-weight: 500;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    line-height: 140%;
}
.modal-wrapper {
    position: fixed;
    width: 70vh;
    z-index: 1000;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.content-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 70000;
    width: 100vw;
    height: 100vh;
}
.modal-buttons {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
}
.modal-button {
    flex-grow: 1;
}
.br-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 60000;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.281) !important;
}

.modal-body-text {
    font-size: 3vh;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
    .modal-wrapper {
        position: fixed;
        z-index: 1000;
        width: 95%;
        margin: 0vh;
    }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
    .modal-wrapper {
        position: fixed;
        width: 70vh;
        z-index: 1000;
    }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .modal-wrapper {
        position: fixed;
        width: 70vh;
        z-index: 1000;
    }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
    .modal-wrapper {
        position: fixed;
        width: 70vh;
        z-index: 1000;
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .modal-wrapper {
        position: fixed;
        width: 70vh;
        z-index: 1000;
    }
}
</style>
